import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip, useNotificationsStore } from '@thermon-platforms/thermon-ui-core';
import ManageDevices from './manage-devices';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';
import AssignDevice from './components/assign-device';
import Firmware from './components/firmware';
import UpgradeController from './components/upgrade-controller';
import RefreshController from './components/refresh-controller';
import { downloadFile } from 'util/api';
import ReassignDevice from './components/reassign-device';


function EditView({device}) {
  const navigate = useNavigate();
  const [, notificationsStoreActions] = useNotificationsStore();
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();

  if (!usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles)) {
    navigate('');
    return;
  }

  function downloadConfig() {
    downloadFile(`/devices/downloadNetworkConfig`, 'genesis-network-config.zip')
      .catch(() => {
        notificationsStoreActions.notify(
          t`An error occurred downloading config data.`,
          'alert'
        );
      });
  }

  return (<>
    <header>
      <h2>{device?.model?.name}</h2>
      <ul className="device-controls">
        <li>
          <Link
            to={''}
            className="button close"
            data-tooltip-content={t`Exit Network Settings`}
            data-tooltip-id="control-tooltip"
          >
            <Trans>Exit Network Settings</Trans>
          </Link>
        </li>
      </ul>
      <Tooltip id="control-tooltip" place="bottom-end" />
    </header>
    <section>
      {(device.model.type == 'Bridge' || device.model.type == 'Controller') && !device.path.length ?
        <AssignDevice device={device} /> :
        <ManageDevices device={device} />
      }
      {
        ![18, 19, 31, 44].includes(device.model.deviceModel) && // Ignore HTCs and Duo controller and Panel
        ['Bridge', 'Panel', 'Controller'].includes(device.model.type) && // Only allow real devices
        device.path.length ? // And make sure we have parent device info to reassign
        <ReassignDevice device={device} />
      : null}
      {device.model.type == 'Site' ? <>
        <Firmware />
        <br /><br />
        <p>
          <span
            className="link download"
            onClick={downloadConfig}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                downloadConfig();
              }
            }}
          >
            <span><Trans>Download Network Configuration</Trans></span>
          </span>
        </p>
      </> : null}
      {[4,5,6,13].includes(device.model.deviceModel) ? <>
        <UpgradeController device={device} />
      </> : null}
      {device.model.type == 'Controller'  ?
        <RefreshController device={device} />
      : null}
    </section>
  </>);
}

export default EditView;
